import React from 'react'
import { View, Switch } from 'react-native'
import Text from "theme/Text";
import ThemedPressable from 'components/atoms/ThemedPressable'
import isEqual from 'react-fast-compare'
import { layoutStyles } from 'styles/layout'
import { themedToggleStyles } from 'styles/components/atoms/ThemedToggle'
import { colorList } from 'utils/colors';

const Toggle = ( { onPress = null, checked = false, text = null, children = null } ) => {

	return (
		<ThemedPressable
			onPress={ onPress }>
			
			<View
				style={ themedToggleStyles.view }>
				
				<Switch
					style={ themedToggleStyles.toggle }
					trackColor={{
						false: colorList.GREY.light, 
						true: colorList.PRIMARY.light
					}}
					thumbColor={ checked ? colorList.PRIMARY.primary : colorList.GREY.primary }
					ios_backgroundColor={ colorList.GREY.light }
					onValueChange={ onPress }
					value={ checked }
				/>
				
				<Text
					appearance={"hint"}
					style={ layoutStyles.flexOne }>
					
					{ text || children }
				</Text>
			</View>
			
			{/* Overlay over the text (and toggle) so the toggle is not clickable */}
			<View
				style={ themedToggleStyles.overlay }
			/>
		</ThemedPressable>
	)
}

export default React.memo( Toggle, isEqual );
